<template>
    <div class="col-12 comment-block">
        <div class="col-md-2 first">
            <span>Valoraciones</span>

            <h1>{{ratingBy10Formatted}}</h1>

            <star-rating :read-only="true" :rating="rating" :show-rating="false" :star-size="20"></star-rating>

            <div class="num_values"><i class="fa fa-user-alt"></i>  {{numValoracion}} en total</div>
        </div>
        <div class="col-md-3">
            <div class="row values_stats">
                <div class="col-12">
                    <i class="fa fa-star"></i> <span>5</span>
                    <div>
                        <div class="value_bar" :style="(this.stats[5]>0)?'width:'+(this.stats[5]*100)/this.valoraciones.length+'%;':'width:0%;'"></div>
                    </div>
                </div>
                <div class="col-12">
                    <i class="fa fa-star"></i> <span>4</span>
                    <div>
                        <div class="value_bar" :style="(this.stats[4]>0)?'width:'+(this.stats[4]*100)/this.valoraciones.length+'%;':'width:0%;'"></div>
                    </div>
                </div>
                <div class="col-12">
                    <i class="fa fa-star"></i> <span>3</span>
                    <div>
                        <div class="value_bar" :style="(this.stats[3]>0)?'width:'+(this.stats[3]*100)/this.valoraciones.length+'%;':'width:0%;'"></div>
                    </div>
                </div>
                <div class="col-12">
                    <i class="fa fa-star"></i> <span>2</span>
                    <div>
                        <div class="value_bar" :style="(this.stats[2]>0)?'width:'+(this.stats[2]*100)/this.valoraciones.length+'%;':'width:0%;'"></div>
                    </div>
                </div>
                <div class="col-12">
                    <i class="fa fa-star"></i> <span>1</span>
                    <div>
                        <div class="value_bar" :style="(this.stats[1]>0)?'width:'+(this.stats[1]*100)/this.valoraciones.length+'%;':'width:0%;'"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-7">
            <swiper v-if="!loading" ref="comment-swiper" :options="swiperOption">
                <swiper-slide v-for="values in valoraciones" :key="values.id">
                    <div class="testimonio_user_block">
                        <h3><b>{{values.nombre ? values.nombre : 'Desconocido'}}</b> - {{ values.provincia }}</h3>
                        <star-rating :read-only="true" :rating="values.rating" :show-rating="false" :star-size="20"></star-rating>
                        <p class="comment">{{values.comment}}</p>
                        <p>Valorado: {{moment(values.created_at).format('DD/MM/YYYY')}}</p>
                    </div>
                </swiper-slide>
                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
            <load-spiner v-else></load-spiner>
        </div>
    </div>
</template>

<script>
import StarRating from 'vue-star-rating';
export default {
    name: "ValoracionesShow",
    components: {StarRating},
    props: {
        rating: {},
        numValoracion: {},
        variedadId: {},
        poliVariedadId: {},
    },
    data() {
        return {
            valoraciones: [],
            moment,
            loading: false,
            swiperOption: {
                slidesPerView: 1,
                spaceBetween: 30,
                loop: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            }
        }
    },
    computed: {
        stats() {
            let stats = {
                1: 0,
                2: 0,
                3: 0,
                4: 0,
                5: 0,
            };
            for (var i=0;i<this.valoraciones.length;i++) {
                var val = this.valoraciones[i];
                stats[val.rating] += 1;
            }
            return stats;
        },
        ratingBy10() {
            return this.rating * 2;
        },
        ratingBy10Formatted() {
            let rating = '-';
            if (this.ratingBy10 > 0) {
                rating = this.ratingBy10.toFixed(1);
            }
            return rating;
        }
    },
    methods: {
        loadRates: function () {
            this.loading = true;
            let data = {};
            if (this.poliVariedadId) {
                data.poli_variedad_id = this.poliVariedadId;
            } else {
                data.variedad_id = this.variedadId;
            }
            axios.post(this.route('custom.get-rates-info'), data).then(response => {
                if(response.data) {
                    this.valoraciones = response.data;
                }
                this.loading = false;
            }).catch(e => {
                console.log(e);
            });
        }
    },
    created() {
        this.loadRates();
    }
}
</script>

<style scoped>
.num_values {
    color: #0071bc;
    font-weight: bold;
    font-size: 12px;
}

.comment-block {
    background-color: #e6e6e6;
    padding: 13px 0px;
    display: flex;
}

.comment-block .first span {
    color: #0071bc;
    font-weight: bold;
}

.comment-block .first h1 {
    font-weight: 800;
    font-size: 60px;
    color: #b3b3b3;
    margin: 0px;
}

.comment-block .first .num_values {
    color: black;
    font-weight: 500;
}

.comment-block .values_stats i {
    color: #ffd055;
}

.comment-block .values_stats > div {
    padding: 2px 0px;
}

.comment-block .values_stats > div span {
    font-weight: bold;
    color: #8c8c8c;
}

.comment-block .values_stats > div > div {
    width: 85%;
    background-color: #d4d4d4;
    height: 10px;
    right: 0;
    position: absolute;
    top: 8px;
}

.comment-block .values_stats > div > div > div.value_bar {
    background-color: #b3b3b3;
    height: 100%;
    position: relative;
}

.comment-block .first {
    text-align: center;
}

.swiper-button-prev, .swiper-button-next {
    box-shadow: none;
    background-color: transparent!important;
}

.testimonio_user_block {
    padding: 10px 80px;
    padding-bottom: 0;
}

.testimonio_user_block h3 {
    font-size: 16px;
    margin: 0;
}

.testimonio_user_block p.comment {
    min-height: 50px;
}

</style>
